import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { AdjustmentRuleAction } from '@cbridge-packages/adjustment-rules';
import { RulesManagementAction, makeRuleRowModelAndState } from '@cbridge-modules/rules-management-page';

export const onLoadAdjustmentRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(
    AdjustmentRuleAction.loadList.done,
  ),
  mergeMap((payload) => {
    const { rows, initialState } = makeRuleRowModelAndState(payload.result);
    return [
      RulesManagementAction.updateState({ ...initialState, rules: rows }),
    ];
  }),
);
